<template>
  <b-row>
    <b-col>
      <v-select
        :id="fieldName"
        v-model="localValue"
        :items="options"
        :required="required"
        :label="label"
        height="35"
        :multiple="multiple"
        clearable
        small-chips
        chips
        deletable-chips
        v-bind="$attrs"
        solor
      ></v-select>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    fieldName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    },
    value: {
      required: true,
      default: ""
    }
  },
  computed: {
    localValue: {
      get() {
        if (!this.multiple) return this.value[0];
        return this.value;
      },
      set(val) {
        if (this.multiple) val = this.setAny(this.localValue, val);
        else {
          val = !!val ? [val] : ["any"];
        }
        this.$emit("input", val);
      }
    }
  },
  methods: {
    setAny(oldVal, newVal) {
      const oldContainsAny = oldVal.includes("any");
      const newContainsAny = newVal.includes("any");

      if (!newVal.length) return ["any"];

      if (!newContainsAny) return newVal;

      if (!oldContainsAny) return ["any"];

      if (oldContainsAny) {
        let index = newVal.indexOf("any");
        newVal.splice(index, 1);
      }

      return newVal;
    }
  }
};
</script>

<style lang="scss" scoped></style>
